
	import {
		Component,
		Vue,
		Prop,
		Watch,
		Emit,
		Mixins
	} from "vue-property-decorator";
    import vselect3 from "vselect3";
    import { validationMixin } from "vuelidate";
	import { required, requiredIf} from "vuelidate/lib/validators";
    import { namespace } from "vuex-class";
    import { Guard, GuardType, PatrolZone, AlarmFilter } from '@/store/dispatch/types';
    import UpdateMultipleGuardsDTO  from "@/types/UpdateMultipleGuardsDTO";
    import { ActionState } from "@/types/ActionState";
        
    const Dispatch = namespace('dispatch');

    @Component({
        mixins: [validationMixin],
        components: {
            "v-select-3": vselect3,
        },
        validations: {
            updatedDetails: {
                alarmQueueFilterId: {
                    required: requiredIf(function() {
					    return this.updatedDetails.updateAlarmQueueFilter;
				    }),
                },
                guardTypeId: {
                    required: requiredIf(function() {
					    return this.updatedDetails.updateGuardType;
				    }),
                },
                patrolZoneId: {
                    required: requiredIf(function() {
					    return this.updatedDetails.updatePatrolZone;
				    }),
                }
            }
        }
    })
    export default class BulkEditDialog extends Vue {
        @Dispatch.State (state => state.BulkEditDialogOpen) bulkEditDialogOpen: boolean;
        @Dispatch.State (state => state.GuardTypes) guardTypes: GuardType[];
        @Dispatch.State (state => state.AlarmFilters) alarmFilters: AlarmFilter[];
        @Dispatch.Mutation setBulkEditDialogOpen:(open: boolean) => void;
        @Dispatch.Action updateMultipleGuards:(data: UpdateMultipleGuardsDTO) => Promise<void>;

        @Prop({ type: Array, default: () => [] }) selectedGuards: Guard[];
        @Prop({ type: Array, default: () => [] }) availableZones: PatrolZone[];

        private updatedDetails: UpdateMultipleGuardsDTO = {
            guardIds:[],
            updateAlarmQueueFilter: false,
            alarmQueueFilterId: null,
            updateGuardType: false,
            guardTypeId: null,
            updatePatrolZone: false,
            patrolZoneId: null
        };

        public updateState: ActionState = ActionState.Undefined;

        public mounted() {
            this.setBulkEditDialogOpen(false);
            this.resetData();
        }

        // Resets the data
        private resetData() : void {
            this.updateState = ActionState.Undefined;
            this.updatedDetails = {
                guardIds:[],
                updateAlarmQueueFilter: false,
                alarmQueueFilterId: null,
                updateGuardType: false,
                guardTypeId: null,
                updatePatrolZone: false,
                patrolZoneId: null
            };
        }

        // Opens the dialog when the state changes
        @Watch("bulkEditDialogOpen")
        private onBulkEditDialogOpen(value: boolean, oldValue: boolean): void {
            if (value) {
                // open - reset the data as could have been opened previously
                this.resetData();
            } 
        }

        // Gets an array of selected guardID's from the array of selected Guards
        private getSelectedGuardIds(): number[] {
            return this.selectedGuards.map(g => g.guardID);
        }

        // Performs the update
        private async updateGuards(): Promise<void> {
            // Set the Id on the request and call the Action (api)
            this.updatedDetails.guardIds = this.getSelectedGuardIds();

            this.updateState = ActionState.InProcess;
            await this.updateMultipleGuards(this.updatedDetails);
            this.updateState = ActionState.Success;

            // Close the dialog
            this.setBulkEditDialogOpen(false);
            
             // Emit an event the parent will list for to trigger a refresh
            this.$emit("refresh", null);
        }

        // Hanldes the cancel click 
        private cancel(): void {
            this.setBulkEditDialogOpen(false);
        }

        // Revalidates the data using vuelidate
        private revalidate(): void {
            this.$v.$touch();
        }

        // Checks if any the checkboxes are checked 
        private get optionSelected (): boolean {
            return (this.updatedDetails.updateAlarmQueueFilter || this.updatedDetails.updateGuardType ||
                    this.updatedDetails.updatePatrolZone);
        }

        // Checks if the update button should be enabled
        public get updateEnabled(): boolean {
            return this.optionSelected && !this.$v.$error;
        }

        // Builds a comma seperated string of the callsigns of all guards selected
        public get editingGuardDetails(): string {
            // concatonate and comma seperate the call signs
            var combinedString:string = this.selectedGuards.map(g => g.callsign).join(', ');
            // remove the trailing comma
            combinedString = combinedString.replace(/,(\s+)?$/, '');
            
            return combinedString;
        }

        // Gets the enum so it can be referenced in the template
        public get actionState (): typeof ActionState {
            return ActionState;
        }
    }
